// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".error-msg-con .t-icon[data-v-4571bb64] {\n  background-color: #E8465A;\n  margin-right: 6px;\n}\n.error-msg-con p[data-v-4571bb64] {\n  margin: 0;\n  flex-basis: 97%;\n}\n", ""]);
// Exports
module.exports = exports;
